module.exports = __webpack_public_path__ + "img/lezhi04.bc2eaf85.png";